import { useChat } from '@ai-sdk/react';
import { useEffect, useRef } from 'react';
import {
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
} from '@mui/material';

const apiUrl = process.env.REACT_APP_API_URL;

export default function InvestorChat() {
  const { messages, input, handleInputChange, handleSubmit, status } = useChat({
    api: apiUrl,
    streamProtocol: 'text',
  });

  // eslint-disable-next-line no-mixed-operators
  const chatContainerRef = useRef(null);
  const bottomRef = useRef(null);

  // useEffect(() => {
  //   bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  // }, [messages]);
  useEffect(() => {
    if (bottomRef.current && chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const isDisabled = status === 'submitted' || status === 'streaming';
  const buttonText =
    status === 'submitted'
      ? 'Sending...'
      : status === 'streaming'
      ? 'Receiving...'
      : 'Send';

  return (
    <Container maxWidth="md" sx={{ minHeight: '100vh', py: 4, display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Box textAlign="center" mb={4}>
        <Typography variant="h5" fontWeight="bold" color="text.primary">
          Investor AI Assistant
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Ask about our strategy, investments, or markets...
        </Typography>
      </Box>

      {/* Chat container */}
      <Paper
        elevation={1}
        sx={{
          flex: 1,
          overflowY: 'auto',
          p: 2,
          mb: 2,
          borderRadius: 2,
          bgcolor: '#fff',
          maxHeight: '50vh', 
        }}
        ref={chatContainerRef}
      >
        {messages.length === 0 ? (
          <Box
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            py={8}
          >
            <Box maxWidth="md">
              <Typography variant="h6" color="text.secondary" gutterBottom>
                No messages yet
              </Typography>
              <Typography variant="body2" color="text.disabled">
                Send a message to get started
              </Typography>
            </Box>
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gap={1} sx={{ overflowY: 'auto', flexGrow: 1 }}>
            {messages.map((m) => (
              <Box
                key={m.id}
                display="flex"
                justifyContent={m.role === 'user' ? 'flex-end' : 'flex-start'}
              >
                <Box
                  sx={{
                    bgcolor: m.role === 'user' ? 'primary.main' : 'grey.100',
                    color: m.role === 'user' ? 'primary.contrastText' : 'text.primary',
                    px: 2,
                    py: 1.5,
                    borderRadius: 3,
                    borderBottomRightRadius: m.role === 'user' ? 0 : 3,
                    borderBottomLeftRadius: m.role === 'user' ? 3 : 0,
                    maxWidth: '85%',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  {m.content}
                </Box>
              </Box>
            ))}
            <div ref={bottomRef} style={{ height: '1px' }} />
          </Box>
        )}
      </Paper>

      {/* Input area */}
      <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
        <form onSubmit={handleSubmit}>
          <Box display="flex" gap={2}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Type your message..."
              value={input}
              onChange={handleInputChange}
              disabled={isDisabled}
              InputProps={{
                sx: { bgcolor: '#f9f9f9' },
              }}
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isDisabled}
              sx={{ px: 4 }}
            >
              {buttonText}
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
}
